import request from '../config/axiosConfig';
import {
  GET_BANNER_POPUP_TYPES,
  GET_BANNERS,
  GET_CAMPAIGNS,
  GET_DATA_STATISTICS,
  GET_DIMENSIONS,
  GET_GRAPHICAL_STATISTICS,
  GET_LICH_VIET_CAMPAIGNS,
  GET_METRICS,
  GET_PARTNERS,
  GET_PLATFORMS,
  GET_POPUPS,
  GET_POSITIONS,
} from '../constants/apiEndPoint';

export const getDataStatisticCampaignRequest = async (data) => {
  const result = await request({
    url: GET_DATA_STATISTICS,
    method: 'POST',
    data,
  });
  return result?.data?.data;
};

export const getGraphicalStatisticCampaignRequest = async (data) => {
  const result = await request({
    url: GET_GRAPHICAL_STATISTICS,
    method: 'POST',
    data,
  });
  return result?.data?.data;
};

export const getListDimensionsRequest = async (data) => {
  const result = await request({
    url: GET_DIMENSIONS,
    method: 'POST',
    data,
  });
  return result?.data?.data?.data;
};

export const getListMetricsRequest = async (data) => {
  const result = await request({
    url: GET_METRICS,
    method: 'POST',
    data,
  });
  return result?.data?.data?.data;
};

export const getListBannerPopupTypesRequest = async (data) => {
  const result = await request({
    url: GET_BANNER_POPUP_TYPES,
    method: 'POST',
    data,
  });
  return result?.data?.data?.data;
};

export const getListPositionsRequest = async (data) => {
  const result = await request({
    url: GET_POSITIONS,
    method: 'POST',
    data,
  });
  return result?.data?.data?.data;
};

export const getListPlatformsRequest = async (data) => {
  const result = await request({
    url: GET_PLATFORMS,
    method: 'POST',
    data,
  });
  return result?.data?.data?.data;
};

export const getListAllPartnersRequest = async (data) => {
  const result = await request({
    url: GET_PARTNERS,
    method: 'POST',
    data,
  });
  return result?.data?.data?.data;
};

export const getListAllCampaignsRequest = async (data) => {
  const result = await request({
    url: GET_CAMPAIGNS,
    method: 'POST',
    data,
  });
  return result?.data?.data?.data;
};

export const getListAllPopupsRequest = async (data) => {
  const result = await request({
    url: GET_POPUPS,
    method: 'POST',
    data,
  });
  return result?.data?.data?.data;
};

export const getListAllBannersRequest = async (data) => {
  const result = await request({
    url: GET_BANNERS,
    method: 'POST',
    data,
  });
  return result?.data?.data?.data;
};

export const getListLichVietCampaignsRequest = async (data) => {
  const result = await request({
    url: GET_LICH_VIET_CAMPAIGNS,
    method: 'POST',
    data,
  });
  return result?.data?.data?.data;
};
